import React from 'react';

const MDTContext = React.createContext(null);
export default MDTContext;
